import { api } from '../../helpers/Api';
var default_1 = /** @class */ (function () {
    function default_1() {
    }
    default_1.prototype.save = function (tiers, stretchId, passengerCategoryId, typePrice, money_id, idaVuelta) {
        var _tiers = tiers.map(function (tier) {
            return {
                id: tier.id,
                idaVuelta: idaVuelta,
                // passengerCategory_id: passengerCategoryId,
                minPax: !tier.minPax && !tier.maxPax ? 1 : tier.minPax,
                maxPax: tier.maxPax,
                price: tier.price,
            };
        });
        return api.post("stretches/".concat(stretchId, "/prices/").concat(passengerCategoryId, "/").concat(typePrice), {
            tiers: _tiers,
            money_id: money_id,
            idaVuelta: idaVuelta,
        });
    };
    return default_1;
}());
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Prices/Store.ts
// module id = 765
// module chunks = 0